import { ISeaJobExperience, SeaJobExperience } from './sea-job-experience';
import { IJobExperience, JobExperience } from './job-experience';

export type JobExperienceType = 'job_experience' | 'sea_services';

export interface IEmploymentHistory {
  job_experience?: IJobExperience[];
  sea_services?: ISeaJobExperience[];
  job_experience_type?: JobExperienceType;
  current_job_month?: number;
}

export class EmploymentHistory {
  job_experience: JobExperience[];
  sea_services: SeaJobExperience[];
  job_experience_type: JobExperienceType;
  current_job_month: number;

  constructor(data: IEmploymentHistory = {}) {
    this.job_experience = data.job_experience
      ? data.job_experience.map((item) => new JobExperience(item))
      : [];
    this.sea_services = data.sea_services
      ? data.sea_services.map((item) => new SeaJobExperience(item))
      : [];
    this.job_experience_type = data.job_experience_type || 'job_experience';
    this.current_job_month = data.current_job_month || 0;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/employment-history.ts